export interface Category {
    ID: string;
    displayName: string;
    url: string;
    showShopAllLink: boolean;
    headerMenuBanner1?: string | null;
    headerMenuBanner2?: string | null;
    headerMenuBanner3?: string | null;
    headerMenuBanner4?: string | null;
    megaNavColumn?: string | null;
    subCategories: Categories;
}

export type Categories = Category[];

export const CATEGORY_BRANDS = 'brands';
export const CATEGORY_SALE = 'sale';
